import script from "./filter-dropdown-trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./filter-dropdown-trigger.vue?vue&type=script&setup=true&lang=ts"

import "./filter-dropdown-trigger.vue?vue&type=style&index=0&id=701a13c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701a13c6"]])

export default __exports__